import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from 'shared/material.module';

import { AppPipesModule } from '@solar/_directives';
import { BaseComponentsModule, DialogsModule } from 'basecomponents';

import { NavbarComponent } from './navbar.component';
import { NavIconToggle1Component } from './nav-icon-toggle-1/nav-icon-toggle1.component';
import { FileUploadModule } from 'guploadmgr';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FSideBarModule } from '../fsidebar/fsidebar.module';
import { NotificationsViewModule } from '../notificationsview/notificationsview.module';





@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule, ReactiveFormsModule
    ,BsDropdownModule
    ,FileUploadModule
    ,AppPipesModule
    ,BaseComponentsModule
    ,FSideBarModule
    ,NotificationsViewModule
  ],
  declarations: [
    NavbarComponent, NavIconToggle1Component


  ],
  entryComponents: []
  ,
  exports: [
    CommonModule,FormsModule, ReactiveFormsModule,
    MaterialModule
    , NavbarComponent
  ]
  ,providers:[
/*     { provide: 'AuthenticationProvider', useClass: AuthenticationService} 
    ,{provide: UPLOAD_SERVICE_CONFIG_TOKEN, useValue: environment.API_UPLOAD_ENDPOINT}  */
  ]
})
export class NavBarModule {
  static forRoot(): ModuleWithProviders<NavBarModule> {
    return {
      ngModule: NavBarModule,
      providers: [
        
      ]
    };
  }
}
